<div class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">Configuration</h3>

    <lib-signal-dropdown
      label="Size"
      [items]="spacerSizeOptions"
      valuePath="value"
      displayPath="label"
      [formField]="configForm.spacerSize" />
  </section>
</div>
